export const WorkshopTypesList = [
  { number: 'Created', color: 'white', type: 'Creado', fix: 'inherit' },
  { number: 'Profiled', color: '#b0acab', type: 'Perfilado', fix: 'white' },
  {
    number: 'ProfiledCompleted',
    color: '#161616',
    type: 'Perfilado Completado',
    fix: 'white',
  },
  { number: 'TaProfiled', color: '#fffe01', type: 'T.A Perfilado', fix: 'inherit' },
  {
    number: 'TaProfiledCompleted',
    color: '#51a634',
    type: 'T.A Perfilado Completado',
    fix: 'white',
  },
  {
    number: 'Censused',
    color: '#5400CB',
    type: 'Censado',
    fix: 'white',
  },
  {
    number: 'TaProfiledIncompleted',
    color: '#ea742d',
    type: 'T.A.perfilado_M.incompleto',
    fix: '#333333',
  },
  {
    number: 'TaVerifiedIncompleted',
    color: '#196b21',
    type: 'T.A_P.Completado_M.incompleto',
    fix: 'white',
  },
  {
    number: 'ProfiledIncompleted',
    color: '#abc8ec',
    type: 'Perfilado_M.incompleto',
    fix: '#333333',
  },
  {
    number: 'VerifiedIncompleted',
    color: '#215c98',
    type: 'P.Completado_M.incompleto',
    fix: 'white',
  },
];
